import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { OrderOverviewReport } from "@/features/office/reports/order-overview";
import {
  filterSearchFragment,
  notificationSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

// Lenient URL schema (strict enums on URL params crash the page — see
// webapp-routing.md). Filter state follows the shared `filters-new` chip DSL:
// a `filters` object + `filtersOrder`. Multi-select facets are comma lists;
// `health` stays a top-level param owned by the health tiles (not a chip), and
// `sort` is the canonical `sort=-field` string driven by the table headers.
const searchSchema = z.object({
  search: z.string().optional().catch(undefined),
  sort: z.string().optional().catch(undefined),
  health: z.string().optional().catch(undefined),
  // Which row's history drawer is open. Lenient like every other URL param —
  // a strict schema here throws SearchParamError and takes down the page.
  orderRow: z.string().optional().catch(undefined),
  filters: z
    .object({
      location: withOperators(commaListSchema),
      orderType: withOperators(commaListSchema),
      orderStatus: withOperators(commaListSchema),
      manager: withOperators(commaListSchema),
      assignee: withOperators(commaListSchema),
      labels: withOperators(commaListSchema),
      ...notificationSearchFragment,
    })
    .optional(),
  ...filterSearchFragment,
  ...maskSearchFragment,
});

export const routeId = "/office/reports/order-overview";
export const Route = createFileRoute("/office/reports/order-overview")({
  validateSearch: searchSchema,
  component: OrderOverviewReport,
});
